// @ts-nocheck
import { RouteRecordRaw } from 'vue-router';
import * as dataUtils from '../utils/dataUtils'
import { ref } from "vue";
import Layout from '@/layout/layout.vue';
import { component } from 'v-viewer';

const commonRoutes: any = [
  {
    path: '/',
    name: 'login',
    redirect: '/login',
    meta: {
      title: '首页',
      renderMenu: false,
      icon: 'HomeOutlined',
    },
  },
  {
    path: '/front',
    name: '前端',
    meta: {
      renderMenu: false,
    },
    children: [
      {
        path: '/login',
        name: '登录',
        meta: {
          icon: 'LoginOutlined',
          view: 'blank',
          target: '_blank',
          cacheable: false,
        },
        component: () => import('@/pages/login/login.vue'),
      },

    ],
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   name: '404',
  //   meta: {
  //     icon: 'CreditCardOutlined',
  //     renderMenu: false,
  //     cacheable: false,
  //   },
  //   component: () => import('@/pages/Exp404.vue'),
  // },

]


const userRoutes: any = [
  {
    path: '/workplace',
    name: '工作台',
    component: Layout,
    meta: {
      icon: 'DashboardOutlined',
    },
    children: [
      {
        path: '/workplace',
        name: '统计',
        component: () => import('@/pages/workplace/workplace.vue')
      }
    ],
  },
  {
    path: '/task-module',
    name: '任效相关',
    component: Layout,
    meta: {
      icon: 'ScheduleOutlined',
    },
    children: [
      {
        path: '/task-module/task',
        name: '任效管理',
        component: () => import('@/pages/task-module/task/task.vue')
      },
      {
        path: '/task-module/task-category',
        name: '任效类目',
        component: () => import('@/pages/task-module/task-category/task-category.vue')
      }
    ],
  },
  {
    path: '/device-module',
    name: '设备相关',
    component: Layout,
    meta: {
      icon: 'ScheduleOutlined',
    },
    children: [
      {
        path: '/device-module/device',
        name: '设备管理',
        component: () => import('@/pages/device-module/device/device.vue')
      },

    ],
  },
  {
    path: '/label-module',
    name: '标注相关',
    component: Layout,
    meta: {
      icon: 'ScheduleOutlined',
    },
    children: [
      {
        path: '/label-module/labeler',
        name: '标注人员管理',
        component: () => import('@/pages/label-module/labeler/labeler.vue')
      },
      {
        path: '/device-module/device-report',
        name: '数据上报管理',
        component: () => import('@/pages/device-module/device-report/device-report.vue')
      },
      {
        path: '/label-module/label-group',
        name: '标注批次管理',
        component: () => import('@/pages/label-module/label-group/label-group.vue')
      },
      {
        path: '/label-module/labeling-review',
        name: '数据标注',
        component: () => import('@/pages/label-module/label-image-review/label-image-review.vue'),
        meta: {
          renderMenu: false
        }
      },
    ],
  },
  {
    path: '/algorithm-module',
    name: '算法相关',
    component: Layout,
    meta: {
      icon: 'ScheduleOutlined',
    },
    children: [
      {
        path: '/algorithm-module/yolo',
        name: 'YOLO模型管理',
        component: () => import('@/pages/algorithm-module/yolo/yolo.vue')
      },
      {
        path: '/algorithm-module/version',
        name: '算法版本管理',
        component: () => import('@/pages/algorithm-module/version/version.vue')
      },
    ],
  },
  {

    path: '/ai-module',
    name: 'AI相关',
    component: Layout,
    meta: {
      icon: 'ScheduleOutlined',
    },
    children: [
      {
        path: '/ai-module/task-report',
        name: '任效上报',
        component: () => import('@/pages/ai-module/task-report/task-report.vue')
      },
    ],
  },

  // {
  //   path: '/dept-module',
  //   name: '部门相关',
  //   component: Layout,
  //   meta: {
  //     icon: 'DashboardOutlined',
  //   },
  //   children: [
  //     {
  //       path: '/dept-module/dept',
  //       name: '部门管理',
  //       component: () => import('@/pages/dept-module/dept/dept.vue')
  //     }
  //   ],
  // },
  {
    path: '/system-module',
    name: '系统相关',
    component: Layout,
    meta: {
      icon: 'UserOutlined',
    },
    children: [
      {
        path: '/system-module/role',
        name: '角色管理',
        component: () => import('@/pages/system-module/role/role.vue')
      },
      {
        path: '/system-module/org',
        name: '部门管理',
        component: () => import('@/pages/system-module/org/org.vue')
      }
    ],
  },
]

export const routes: any[] = [...commonRoutes, ...userRoutes];
